import { IonAvatar, IonCard, IonIcon, IonImg } from "@ionic/react";
import { ReactComponent as TradesIcon } from "../assets/graphics/mode_heat.svg";
import { ReactComponent as StreaksIcon } from "../assets/graphics/mode_streaks.svg";
import UserName from "./UserName";
import { arrowDown } from "ionicons/icons";
import ProfitIndicator from "./ProfitIndicator";

interface Props {
  lobby: any;
}

const PrizeSummary: React.FC<Props> = ({ lobby }) => {
  const mostTradesBot = lobby?.standings?.find((s: any) =>
    s?.prizes?.find((p: any) => p.name === "mostTrades")
  );
  const profitStreakBot = lobby?.standings?.find((s: any) =>
    s?.prizes?.find((p: any) => p.name === "profitStreak")
  );
  const biggestLoserBot = lobby?.standings?.find((s: any) =>
    s?.prizes?.find((p: any) => p.name === "biggestLoser")
  );

  return (
    <>
      <IonCard>
        <div className="flex flex-col grow rounded-t-lg bg-primary-70">
          <div className="flex items-center m-2">
            <div className="bg-[#ff7f0a] opacity-70 p-[2px] rounded h-4 mr-1">
              <TradesIcon />
            </div>
            <div className="text-lg ml-2 font-semibold text-white">
              Most Trades
            </div>
          </div>
          <div>
            <div className="flex items-center bg-primary-90 p-2">
              <IonAvatar className="h-9 w-9">
                <IonImg src={mostTradesBot?.img} />
                <span className="absolute -mt-3 px-1 rounded-full bg-primary-90 text-yellow-400 text-sm">
                  {lobby?.standings?.findIndex(
                    (s: any) => s.botId === mostTradesBot?.botId
                  ) + 1}
                </span>
              </IonAvatar>
              <div className="flex flex-col justify-center px-2 text-sm text-white capatilize">
                {mostTradesBot?.name}
                <UserName userId={mostTradesBot?.user} />
              </div>
              <div className="flex justify-end grow">
                <div className="bg-[#ff7f0a] opacity-70 p-[2px] rounded h-4 mr-1">
                  <TradesIcon />
                </div>
                {mostTradesBot?.tradeCount}
              </div>
            </div>
          </div>
        </div>
      </IonCard>
      <IonCard>
        <div className="flex flex-col grow rounded-t-lg bg-primary-70">
          <div className="flex items-center m-2">
            <div>
              <StreaksIcon />
            </div>
            <div className="text-lg ml-2 font-semibold text-white">
              Longest Profit Streak
            </div>
          </div>
          <div>
            <div className="flex items-center bg-primary-90 p-2">
              <IonAvatar className="h-9 w-9">
                <IonImg src={profitStreakBot?.img} />
                <span className="absolute -mt-3 px-1 rounded-full bg-primary-90 text-yellow-400 text-sm">
                  {lobby?.standings?.findIndex(
                    (s: any) => s.botId === profitStreakBot?.botId
                  ) + 1}
                </span>
              </IonAvatar>
              <div className="flex flex-col justify-center px-2 text-sm text-white capatilize">
                {profitStreakBot?.name}
                <UserName userId={profitStreakBot?.user} />
              </div>
              <div className="flex items-center justify-end grow">
                <div>
                  <StreaksIcon />
                </div>
                {profitStreakBot?.maxProfitStreak}
              </div>
            </div>
          </div>
        </div>
      </IonCard>
      <IonCard>
        <div className="flex flex-col grow rounded-t-lg bg-primary-70">
          <div className="flex items-center m-2">
            <div className="bg-red-800 text-red-400 bg-opacity-70 p-[2px] rounded h-4 mr-1">
              <IonIcon icon={arrowDown} />
            </div>
            <div className="text-lg ml-2 font-semibold text-white">
              Biggest Loser
            </div>
          </div>
          <div>
            <div className="flex items-center bg-primary-90 p-2">
              <IonAvatar className="h-9 w-9">
                <IonImg src={biggestLoserBot?.img} />
                <span className="absolute -mt-3 px-1 rounded-full bg-primary-90 text-yellow-400 text-sm">
                  {lobby?.standings?.findIndex(
                    (s: any) => s.botId === biggestLoserBot?.botId
                  ) + 1}
                </span>
              </IonAvatar>
              <div className="flex flex-col justify-center px-2 text-sm text-white capatilize">
                {biggestLoserBot?.name}
                <UserName userId={biggestLoserBot?.user} />
              </div>
              <div className="flex items-center justify-end grow">
                <ProfitIndicator profit={biggestLoserBot?.profit} />
              </div>
            </div>
          </div>
        </div>
      </IonCard>
    </>
  );
};

export default PrizeSummary;
